import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

export const CompanyFilterComp = (params) => {
  const {
    companyData,
    setCompanyName,
    companyName,
    countryData,
    country,
    setCountry,
    handleFilterChange,
    statusData,
    status,
    setStatus,
    ClearFilter,
    ApplyFilter,
    companyFilter,
  } = params;
  return (
    <div
      className="modal fade drawer right-align"
      id="filterRightSideModalPopup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="filterRightSideModalPopupLabel"
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <i className="fas fa-filter"></i>
            <h5 className="modal-title">Filters</h5>
            <i className="fas fa-times" data-dismiss="modal"></i>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="mt-2">
                  <label>Company</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_COMPANY}
                    pageName="company"
                    dpDownName="company"
                    stateData={companyData}
                    controlName="companydrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "id");
                    }}
                    value={companyName}
                    valueId={companyFilter?.id}
                    setState={setCompanyName}
                    multiSelect={true}
                    styles={style}
                  />
                </div>
                <div className="mt-2">
                  <label>Country</label>
                  <DropDownComponent
                    placeHolder={PlaceHolder.SELECT_COUNTRY}
                    pageName="company"
                    dpDownName="country"
                    stateData={countryData}
                    controlName="countrydrp"
                    handleChange={(e) => {
                      handleFilterChange(e, "countryId");
                    }}
                    value={country}
                    valueId={companyFilter?.countryId}
                    setState={setCountry}
                    multiSelect={true}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="footer-modal">
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn clear-all-btn"
                    data-dismiss="modal"
                    onClick={(e) => ClearFilter()}
                  >
                    Clear all
                  </button>
                  <button
                    type="button"
                    className="btn apply-btn"
                    data-dismiss="modal"
                    onClick={(e) => ApplyFilter()}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
